import {
  UpdateUserOrgPreferencesRequest,
  UserOrgPreferencesDto,
} from "../../common/service/server/dto/UserDto";
import { useDataRequest } from "../../common/hooks/api";
import { Api } from "../../common/service/Api";
import { Error as RequestsError } from "../copy/requests";
import { NetworkRequestState } from "../../common/models";
import { OrganizationPublicId } from "../../common/service/server/Types";
import { useMutation } from "@tanstack/react-query";

export const useAllUserOrgPreferences = (): [
  UserOrgPreferencesDto[],
  NetworkRequestState,
  () => void,
] => {
  const { refresh, request, result } = useDataRequest({
    queryKey: ["allUserOrgPreferences"],
    api: () => Api.user.getAllUserOrgPreferences(),
    messages: {
      defaultError: RequestsError.GetAllUserOrgPreferences,
    },
  });

  return [result, request, refresh];
};

export const useUpdateUserOrgPreferences = () => {
  const { mutateAsync: updateUserOrgPreferences, ...rest } = useMutation({
    mutationFn: async ({
      organizationId,
      preferences,
    }: {
      organizationId: OrganizationPublicId;
      preferences: UpdateUserOrgPreferencesRequest;
    }) => Api.user.updateUserOrgPreferences(organizationId, preferences),
  });

  return { updateUserOrgPreferences, ...rest };
};
